import * as React from "react";

export const useDebounce = (props: { timeoutInMilliseconds: number }) => {
  const [currentTimeout, setCurrentTimeout] =
    React.useState<NodeJS.Timer | null>(null);

  const debounce = (action: () => unknown) => {
    if (currentTimeout) {
      clearTimeout(currentTimeout);
    }

    const newTimeout = setTimeout(() => {
      action();
    }, props.timeoutInMilliseconds);

    setCurrentTimeout(newTimeout);
  };

  return debounce;
};
